<template>
    <div style="width: 100%;position: relative">
        <div class="items">
            <div class="item" v-if="activeIndex==1" :class="{'dr':ssEnable,'dc':!ssEnable}">
                <img :src="fileServerUrl+'assets/eight-lb/lb-1.jpg'">
            </div>
            <div class="item" v-if="activeIndex==2" :class="{'dr':ssEnable,'dc':!ssEnable}">
                <img :src="fileServerUrl+'assets/eight-lb/lb-2.jpg'">
            </div>
            <div class="item" v-if="activeIndex==3" :class="{'dr':ssEnable,'dc':!ssEnable}">
                <img :src="fileServerUrl+'assets/eight-lb/lb-3.jpg'">
            </div>
            <div class="item" v-if="activeIndex==4" :class="{'dr':ssEnable,'dc':!ssEnable}">
                <img :src="fileServerUrl+'assets/eight-lb/lb-4.jpg'">
            </div>
            <div class="item" v-if="activeIndex==5" :class="{'dr':ssEnable,'dc':!ssEnable}">
                <img :src="fileServerUrl+'assets/eight-lb/lb-5.jpg'">
            </div>
            <div class="item" v-if="activeIndex==6" :class="{'dr':ssEnable,'dc':!ssEnable}">
                <img :src="fileServerUrl+'assets/eight-lb/lb-6.jpg'">
            </div>
            <div class="item" v-if="activeIndex==7" :class="{'dr':ssEnable,'dc':!ssEnable}">
                <img :src="fileServerUrl+'assets/eight-lb/lb-7.jpg'">
            </div>
            <div class="item" v-if="activeIndex==8" :class="{'dr':ssEnable,'dc':!ssEnable}">
                <img :src="fileServerUrl+'assets/eight-lb/lb-8.jpg'">
            </div>
        </div>
        <div class="menu">
            <div @click="changeIndex(1)" class="hvr-underline-from-left">
                <span :class="{'menu-active':activeIndex==1}">前沿观察</span>
            </div>
            <div @click="changeIndex(2)" class="hvr-underline-from-left">
                <span :class="{'menu-active':activeIndex==2}">意向收集</span>
            </div>
            <div @click="changeIndex(3)" class="hvr-underline-from-left">
                <span :class="{'menu-active':activeIndex==3}">定向邀请</span>
            </div>
            <div @click="changeIndex(4)" class="hvr-underline-from-left">
                <span :class="{'menu-active':activeIndex==4}">闭门交流</span>
            </div>
            <div @click="changeIndex(5)" class="hvr-underline-from-left">
                <span :class="{'menu-active':activeIndex==5}">案例展示</span>
            </div>
            <div @click="changeIndex(6)" class="hvr-underline-from-left">
                <span :class="{'menu-active':activeIndex==6}">定向引荐</span>
            </div>
            <div @click="changeIndex(7)" class="hvr-underline-from-left">
                <span :class="{'menu-active':activeIndex==7}">会后追踪</span>
            </div>
            <div @click="changeIndex(8)" class="hvr-underline-from-left">
                <span :class="{'menu-active':activeIndex==8}">持续精细</span>
            </div>
        </div>
        <div class="zzc" :class="{'ss':ssEnable,'sstz':!ssEnable}">

        </div>
    </div>
</template>

<script>
    export default {
        name: "DemoLb",
        data() {
            return {
                fileServerUrl:fileServerUrl,
                activeIndex:1,
                ssEnable:true,//闪烁开关
            }
        },
        methods:{
            changeIndex(index){
                this.ssEnable = true;
                this.activeIndex = index;
                this.stopSs();
            },
            stopSs(){
                setTimeout(()=>{
                    this.ssEnable = false;
                },200)
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "hover.css";

    .items{
        width: 100%;
        height: 100%;
    }
    .item {
        width: 100%;
        height: 80%;
    }
    .item img{
        width: 100%;
        height: 299px;
    }
    .menu-active{
        border-bottom: 2px solid #42e7fe;
        height: 12px;
        padding-top: 1px;

        //border: 0.1px solid red;

    }
    .menu{
        //border: 0.1px solid red;
        color: #42e7fe;
        font-size: 0.13rem;
        font-family: weiruan;
        width: 55%;
        position: absolute;
        z-index: 3;
        margin-top: -5%;
        top: 312px;
        left: 25%;
        //border: 0.1px solid red;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .menu:hover{
        cursor: pointer;

    }

    .zzc{
        width: 100%;
        height: 310px;
        position: absolute;
        top: 0;
        z-index: 2;
        background-color: #d7d7d7;
    }
    .ss{//闪烁
        opacity: 0;
        transition: all 0.2s;
    }
    .sstz{//遮罩层闪烁用的
        opacity: 0;
        transition: all 0.2s;
    }
    .dr{
        opacity: 0.7;
        transition: all 0.2s;
    }
    .dc{
        opacity: 1;
        transition: all 0.2s;
    }
    .hvr-underline-from-left{
        height: 15px;
    }
    .hvr-underline-from-left:before{
        background: #42e7fe;
    }
</style>
